import * as React from "react"

const Close = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="16" height="16" viewBox="0 0 18 18" {...props}>
    <g clipPath="url(#a)">
      <path d="m9.848 9 4.5 4.5-.848.849-4.5-4.5-4.5 4.5-.848-.848 4.5-4.5-4.5-4.5.848-.849 4.5 4.5 4.5-4.5.848.848-4.5 4.5Z" />
    </g>
    <defs>
      <clipPath id="a">
        <path d="M0 0h18v18H0z" />
      </clipPath>
    </defs>
  </svg>
)

export default Close
